import Image from "next/image";
import Link from "next/link";

const CHOOSE_FEATURES = [
  { id: 1, text: "Christ-Centered Education." },
  { id: 2, text: "High Academic Standards" },
  { id: 3, text: "Safe, supportive and Nurturing Environment (Nurturing and Inclusive environment)" },
  { id: 4, text: "Holistic Development of Every Child" },
  { id: 5, text: "Accredited and established institution" },
  { id: 6, text: "Valued-Based community with Global Perspective" },
  { id: 7, text: "State of the Art Facilities and Modern learning" },
  { id: 8, text: "Supportive Home-School partnership." },

];

const ChooseArea = () => {
  return (
    <section className="choose-area pt-0">
      <div className="container-fluid">
        <div className="row align-items-center">
          {/* Left: Illustration Image */}
          <div className="col-lg-6 ps-0">
            <div className="home-choose-img">
              <Image
                src="/images/choose1.png"
                alt="Why Choose Cayman Academy"
                width={700}
                height={550}
                className="img-fluid w-full"
                priority
              />
            </div>
          </div>

          {/* Right: Text and Features List */}
          <div className="col-lg-6 home-choose">
            <div className="home-choose-content">
              <div className="section-tittle">
                <h2>Why Choose Cayman Academy?</h2>
                <p>
                  A school where Faith, Excellence, and Community come together.
                  Choosing the right school is one of the most important decisions for any family.
                  At Cayman Academy, <b>we provide more than just an education — we offer a nurturing
                    environment where students grow academically, spiritually, socially, and emotionally.</b>
                  Our commitment to excellence, strong values, and personalized learning makes
                  Cayman Academy a place where every child can thrive.
                </p>
              </div>

              <div className="row">
                {/* Features Columns */}
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <ul className="choose-list-left">
                    {CHOOSE_FEATURES.slice(0, 5).map((item) => (
                      <li key={item.id}>
                        <i className="fa-solid fa-circle-check"></i> {item.text}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="choose-list-home">
                    <ul>
                      {CHOOSE_FEATURES.slice(5).map((item) => (
                        <li key={item.id}>
                          <i className="fa-solid fa-circle-check"></i> {item.text}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Call to Action */}
                <div className="col-12 mt-4">
                  <Link href="/about/welcome" className="box-btn">
                    Know More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseArea;
